import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { AbortError } from "./Errors";
import { FetchHttpClient } from "./FetchHttpClient";
import { HttpClient } from "./HttpClient";
import { Platform } from "./Utils";
import { XhrHttpClient } from "./XhrHttpClient";
/** Default implementation of {@link @microsoft/signalr.HttpClient}. */

export var DefaultHttpClient = /*#__PURE__*/function (_HttpClient) {
  _inherits(DefaultHttpClient, _HttpClient);

  var _super = _createSuper(DefaultHttpClient);

  /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */
  function DefaultHttpClient(logger) {
    var _this;

    _classCallCheck(this, DefaultHttpClient);

    _this = _super.call(this);

    if (typeof fetch !== "undefined" || Platform.isNode) {
      _this._httpClient = new FetchHttpClient(logger);
    } else if (typeof XMLHttpRequest !== "undefined") {
      _this._httpClient = new XhrHttpClient(logger);
    } else {
      throw new Error("No usable HttpClient found.");
    }

    return _this;
  }
  /** @inheritDoc */


  _createClass(DefaultHttpClient, [{
    key: "send",
    value: function send(request) {
      // Check that abort was not signaled before calling send
      if (request.abortSignal && request.abortSignal.aborted) {
        return Promise.reject(new AbortError());
      }

      if (!request.method) {
        return Promise.reject(new Error("No method defined."));
      }

      if (!request.url) {
        return Promise.reject(new Error("No url defined."));
      }

      return this._httpClient.send(request);
    }
  }, {
    key: "getCookieString",
    value: function getCookieString(url) {
      return this._httpClient.getCookieString(url);
    }
  }]);

  return DefaultHttpClient;
}(HttpClient);